import { appendSearchParams } from './utils'

export const authorize = async (params: { url: string; clientId: string; state?: string | null }) => {
  const { url, clientId, state } = params

  const authCode = crypto.randomUUID?.() ?? crypto.getRandomValues(new Uint32Array(40)).join('')

  try {
    const result = await fetch(
      appendSearchParams(`${url}/authorize`, {
        clientId,
        authCode,
        state,
        scope: state ? 'state' : null,
      }),
    )
    if (result.ok) {
      return authCode
    } else {
      throw new Error(result.statusText)
    }
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : String(e)
    throw new Error(errorMessage)
  }
}
